type Props = {
  widths: string;
  height: string;
  fillOne: string;
  fillTwo: string;
};

export const LogoMovilSVG = ({
  widths,
  height,
  fillOne,
  fillTwo,
}: Props): JSX.Element => {
  return (
    <svg
      width={widths}
      height={height}
      viewBox={`0 0 ${widths} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M33.0155 8.65894C31.2149 8.65894 28.7179 9.42183 26.9047 11.8933C26.572 12.345 26.2993 12.92 26.1385 13.4853C25.585 15.4108 25.9748 17.5309 27.1907 19.1578C28.1236 20.4081 29.3129 21.3463 30.3621 22.1701C30.8771 22.5728 31.9648 23.5942 32.3153 24.0273C32.8406 24.6773 33.2408 25.0613 33.7135 26.4943C33.9995 27.3635 34.0425 28.5045 33.9017 29.153C37.1894 25.8495 40.7787 21.5625 40.7787 16.901C40.7787 11.5442 36.9079 8.65894 33.0155 8.65894Z"
        fill={fillOne}
      />
      <path
        d="M26.153 26.6155C24.7882 24.7353 23.2077 23.5935 21.9043 22.3901C21.3374 21.8678 20.715 21.4778 20.2534 21.015C18.0431 18.7953 17.0101 16.0549 17.531 12.6853C17.9445 10.0399 19.2434 8.30461 20.8091 7.02764C18.9389 5.63997 16.7182 4.88892 14.2107 4.88892C7.98283 4.88892 2.7797 9.95006 2.93679 16.1916C3.22058 27.4594 17.1672 37.0564 22.9127 39.0235C25.9885 37.4263 27.6194 34.4512 27.6194 31.3988C27.6194 29.1731 26.6747 27.3346 26.153 26.6155Z"
        fill={fillTwo}
      />
    </svg>
  );
};
